import { Component, OnInit } from '@angular/core';
import { ParamMap, Router, ActivatedRoute, Params } from '@angular/router';
import { Http, ResponseContentType } from '@angular/http';
import { commonService } from "../../service/common.service";
import { sessionService } from '../../service/session.service';
import { ToppersService } from '../../service/toppers.service';
import { HttpErrorResponse } from '@angular/common/http';
import { userService } from '../../service/user.service';
import { Globals } from '../../globals';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-topperstalk',
  templateUrl: './topperstalk.component.html',
  styleUrls: ['./topperstalk.component.css'],
  providers: [commonService, sessionService, Globals, ToppersService]
})
export class TopperstalkComponent implements OnInit {

  listingdata: any = [];
  notfound: boolean = false;
  currentPage = 0;
  pageSize = 10;
  end = 100;
  start: Number = 0;
  msg: String = '';
  data = {};
  catdata: Array<any> = [];
  catVal: Array<any> = [];
  totalrow: Number;
  topperHtml: any;
  isPostLoad = false;
  catId = 1; //set default cat id

  constructor(public tp: ToppersService, public router: Router, private sanitizer: DomSanitizer,private route: ActivatedRoute) {
    
   }

  ngOnInit() {
    this.getToppersCategory();
  }

  toppersList(){
    this.isPostLoad = true;
    this.msg = '';
    this.listingdata = [];
    this.tp.getTopperLIsting(this.start, this.end, this.catId).subscribe((data: any) => {
      this.isPostLoad = false;
      if (data) {
        //this.listingdata = this.getNestedChildren(data.results.rows);
      /*if( this.listingdata.count==0){ 
        this.msg = 'No record found!';
      }*/
      this.test(data.results.rows).then( data =>{
        this.listingdata = data;
        
        if( this.listingdata.length==0){ 
          this.msg = 'No record found!';
        }
      })
       
      }
    })
  }

  test(arr){
    return new Promise( (resolve,error) => {
      setTimeout(() => {
        var x = this.getNestedChildren(arr);
        resolve(x);
      },200);
    });
  }
  getNestedChildren(arr) {
    var finalarray = {};
    var goodResponse = [];
    for (var i in arr) {
      if (!finalarray[arr[i].passedYear]) {
        finalarray[arr[i].passedYear] = [];
      }
      finalarray[arr[i].passedYear].push(arr[i]);
    }

    for (let prop in finalarray) {
      finalarray[prop].catTitle = prop;
      goodResponse.push(finalarray[prop]);
    }
    goodResponse.sort(function (b, a) {
      return a.catTitle - b.catTitle;
    });
    return goodResponse;
  }

  detailsPage(userId) {
    //this.router.navigateByUrl('/toppersdetail/' + userId);
  }

  changeCat(catId){
    this.catId = catId;
    this.toppersList();
  }

  getToppersCategory(){
    this.catdata=[];
    let status = '1';
    this.msg = '';
    this.tp.getTopperCatLIsting(this.start,this.end,status).subscribe((data:any)=>{
      if(data){    
        this.catdata = data.results.rows;
        if(this.catdata[0]){
          this.catId = this.catdata[0].id;
          this.toppersList();
        }else{
          this.msg = "No Record Found!";
        }
      }else{
        this.catdata=[];
      }
      })
  
  
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/topperstalk/topperstalk.component.ts